import { render, staticRenderFns } from "./LegendSelector.vue?vue&type=template&id=5ff96fdf&scoped=true&"
import script from "./LegendSelector.vue?vue&type=script&lang=js&"
export * from "./LegendSelector.vue?vue&type=script&lang=js&"
import style0 from "./LegendSelector.vue?vue&type=style&index=0&id=5ff96fdf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff96fdf",
  null
  
)

export default component.exports